import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { OrgEditorModal, PortalButton } from '@custom-components';

function NavOrgEditorModal(props) {
  const { organization, type, subSite, subTitle } = props;
  const [openOrgEditor, setOpenOrgEditor] = useState(false);
  return (
    <>
      <PortalButton
        label="Open Org Editor"
        onClick={() => {
          setOpenOrgEditor(true);
        }}
      />

      {openOrgEditor && (
        <OrgEditorModal
          organization={organization}
          type={type}
          closeModal={() => {
            setOpenOrgEditor(false);
          }}
          subSite={subSite}
          subTitle={subTitle}
        />
      )}
    </>
  );
}

NavOrgEditorModal.propTypes = {
  organization: PropTypes.shape({}).isRequired,
  type: PropTypes.string,
  subSite: PropTypes.string,
  subTitle: PropTypes.string
};
NavOrgEditorModal.defaultProps = {
  type: 'customer',
  subSite: undefined,
  subTitle: ''
};

export default NavOrgEditorModal;
